import { post } from '../..';
import asNumber from '../../../components/AsNumber';

type AddSpacePayload = {
  ParentId: string,
  Space: {
    Name: string,
    Top: number,
    Left: number,
    Right: number,
    Bottom: number,
    Points,
    Polygon,
    Priority: boolean,
    LocationSubtype?: string | null,
    LocationCapacity?: number | null,
    ExternalId?: string,
  },
}

const addSpace = ({
  ParentId,
  Space: {
    Name, Top, Left, Right, Bottom, Points, Polygon, Priority, LocationSubtype, LocationCapacity,
    ExternalId,
  },
}: AddSpacePayload) => {
  const body: AddSpacePayload = {
    Space: {
      Name,
      Top,
      Left,
      Right,
      Bottom,
      Points: Points.map((point: { x: number, y: number, number: number }) => ({
        X: point.x, Y: point.y, Number: point.number,
      })),
      Polygon,
      Priority,
      LocationSubtype,
    },
    ParentId,
  };

  if (ExternalId?.length > 0 && typeof ExternalId === 'string') body.Space.ExternalId = ExternalId;

  if (asNumber(LocationCapacity)) {
    body.Space.LocationCapacity = asNumber(LocationCapacity);
  }

  return post('locations/space', body);
};

export default addSpace;
